import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import University from './pages/university/University';
import Programs from './pages/university/Programs';
import ProgramDetail from './pages/university/ProgramDetail';
import CreateProgram from './pages/university/CreateProgram';
import Applications from './pages/university/Applications';
import IntakePeriods from './pages/university/IntakePeriods';
import Communications from './pages/university/Communications';
import Reports from './pages/university/Reports';
import Settings from './pages/university/Settings';
import Student from './pages/student/Student';
import StudentProgramDetail from './pages/student/ProgramDetail';
import ApplicationForm from './pages/student/ApplicationForm';
import ApplicationConfirmation from './pages/student/ApplicationConfirmation';
import StudentApplications from './pages/student/Applications';
import StudentDocuments from './pages/student/Documents';
import StudentMessages from './pages/student/Messages';
import StudentSettings from './pages/student/Settings';
import Admin from './pages/admin/Admin';
import AdminUniversities from './pages/admin/Universities';
import AdminPrograms from './pages/admin/Programs';
import AdminProgramDetail from './pages/admin/ProgramDetail';
import UniversityDetail from './pages/admin/UniversityDetail';
import AdminApplications from './pages/admin/Applications';
import AdminAnalytics from './pages/admin/Analytics';
import AdminReports from './pages/admin/Reports';
import AdminSettings from './pages/admin/Settings';
import { BuildingIcon } from 'lucide-react';
import './src/styles/fonts.css'; // Updated path to point to the correct location
import { Toaster } from 'sonner';
// Student Scholarship Routes
import Scholarships from './pages/student/Scholarships';
import ScholarshipDetail from './pages/student/ScholarshipDetail';
import ScholarshipApplication from './pages/student/ScholarshipApplication';
import MyScholarships from './pages/student/MyScholarships';
import ApplicationsAndScholarships from './pages/student/ApplicationsAndScholarships';
// Student Exemption Routes
import Exemptions from './pages/student/Exemptions';
import ExemptionWizard from './pages/student/ExemptionWizard';
import ExemptionDetail from './pages/student/ExemptionDetail';
// Employer Routes
import Employer from './pages/employer/Employer';
import EmployerScholarships from './pages/employer/Scholarships';
import CreateScholarship from './pages/employer/CreateScholarship';
import ScholarshipApplications from './pages/employer/ScholarshipApplications';
import Interviews from './pages/employer/Interviews';
// MoHESR Routes
import MoHESR from './pages/mohesr/MoHESR';
import EliteTrack from './pages/mohesr/EliteTrack';
import EligibleLists from './pages/mohesr/EligibleLists';
import PartnershipApprovals from './pages/mohesr/PartnershipApprovals';
import MoHESRApplications from './pages/mohesr/Applications';
import MoHESRReports from './pages/mohesr/Reports';
// Platform Overview
import PlatformOverview from './pages/PlatformOverview';
export function App() {
  return <Router data-id="element-0">
      <div className="min-h-screen bg-gray-50" data-id="element-1">
        <Toaster position="top-right" richColors data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/overview" element={<PlatformOverview data-id="element-7" />} data-id="element-6" />
          {/* University Coordinator Routes */}
          <Route path="/university" element={<University data-id="element-9" />} data-id="element-8" />
          <Route path="/university/programs" element={<Programs data-id="element-11" />} data-id="element-10" />
          <Route path="/university/programs/:programId" element={<ProgramDetail data-id="element-13" />} data-id="element-12" />
          <Route path="/university/programs/create" element={<CreateProgram data-id="element-15" />} data-id="element-14" />
          <Route path="/university/applications" element={<Applications data-id="element-17" />} data-id="element-16" />
          <Route path="/university/applications/intake-periods" element={<IntakePeriods data-id="element-19" />} data-id="element-18" />
          <Route path="/university/communications" element={<Communications data-id="element-21" />} data-id="element-20" />
          <Route path="/university/reports" element={<Reports data-id="element-23" />} data-id="element-22" />
          <Route path="/university/settings" element={<Settings data-id="element-25" />} data-id="element-24" />
          {/* Student Routes */}
          <Route path="/student" element={<Student data-id="element-27" />} data-id="element-26" />
          <Route path="/student/programs" element={<Student data-id="element-29" />} data-id="element-28" />
          <Route path="/student/programs/:programId" element={<StudentProgramDetail data-id="element-31" />} data-id="element-30" />
          <Route path="/student/application/:programId" element={<ApplicationForm data-id="element-33" />} data-id="element-32" />
          <Route path="/student/application-confirmation" element={<ApplicationConfirmation data-id="element-35" />} data-id="element-34" />
          {/* Combined Applications and Scholarships page */}
          <Route path="/student/applications-and-scholarships" element={<ApplicationsAndScholarships data-id="element-37" />} data-id="element-36" />
          {/* Keep original routes but redirect to the new combined page */}
          <Route path="/student/applications" element={<Navigate to="/student/applications-and-scholarships?tab=applications" replace data-id="element-39" />} data-id="element-38" />
          <Route path="/student/my-scholarships" element={<Navigate to="/student/applications-and-scholarships?tab=scholarships" replace data-id="element-41" />} data-id="element-40" />
          {/* Student Exemption Routes */}
          <Route path="/student/exemptions" element={<Navigate to="/student/applications-and-scholarships?tab=exemptions" replace data-id="element-43" />} data-id="element-42" />
          <Route path="/student/exemptions/new" element={<ExemptionWizard data-id="element-45" />} data-id="element-44" />
          <Route path="/student/exemptions/:requestId" element={<ExemptionDetail data-id="element-47" />} data-id="element-46" />
          <Route path="/student/documents" element={<StudentDocuments data-id="element-49" />} data-id="element-48" />
          <Route path="/student/messages" element={<StudentMessages data-id="element-51" />} data-id="element-50" />
          <Route path="/student/settings" element={<StudentSettings data-id="element-53" />} data-id="element-52" />
          {/* Student Scholarship Routes */}
          <Route path="/student/scholarships" element={<Scholarships data-id="element-55" />} data-id="element-54" />
          <Route path="/student/scholarships/:scholarshipId" element={<ScholarshipDetail data-id="element-57" />} data-id="element-56" />
          <Route path="/student/scholarship-application/:scholarshipId" element={<ScholarshipApplication data-id="element-59" />} data-id="element-58" />
          {/* Employer Routes */}
          <Route path="/employer" element={<Employer data-id="element-61" />} data-id="element-60" />
          <Route path="/employer/scholarships" element={<EmployerScholarships data-id="element-63" />} data-id="element-62" />
          <Route path="/employer/create-scholarship" element={<CreateScholarship data-id="element-65" />} data-id="element-64" />
          <Route path="/employer/applications" element={<ScholarshipApplications data-id="element-67" />} data-id="element-66" />
          <Route path="/employer/interviews" element={<Interviews data-id="element-69" />} data-id="element-68" />
          {/* MoHESR Routes */}
          <Route path="/mohesr" element={<MoHESR data-id="element-71" />} data-id="element-70" />
          <Route path="/mohesr/elite-track" element={<EliteTrack data-id="element-73" />} data-id="element-72" />
          <Route path="/mohesr/eligible-lists" element={<EligibleLists data-id="element-75" />} data-id="element-74" />
          <Route path="/mohesr/partnership-approvals" element={<PartnershipApprovals data-id="element-77" />} data-id="element-76" />
          <Route path="/mohesr/applications" element={<MoHESRApplications data-id="element-79" />} data-id="element-78" />
          <Route path="/mohesr/reports" element={<MoHESRReports data-id="element-81" />} data-id="element-80" />
          {/* Admin Routes */}
          <Route path="/admin" element={<Admin data-id="element-83" />} data-id="element-82" />
          <Route path="/admin/universities" element={<AdminUniversities data-id="element-85" />} data-id="element-84" />
          <Route path="/admin/programs" element={<AdminPrograms data-id="element-87" />} data-id="element-86" />
          <Route path="/admin/universities/:universityId" element={<UniversityDetail data-id="element-89" />} data-id="element-88" />
          <Route path="/admin/programs/:programId" element={<AdminProgramDetail data-id="element-91" />} data-id="element-90" />
          <Route path="/admin/applications" element={<AdminApplications data-id="element-93" />} data-id="element-92" />
          <Route path="/admin/analytics" element={<AdminAnalytics data-id="element-95" />} data-id="element-94" />
          <Route path="/admin/reports" element={<AdminReports data-id="element-97" />} data-id="element-96" />
          <Route path="/admin/settings" element={<AdminSettings data-id="element-99" />} data-id="element-98" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-101" />} data-id="element-100" />
        </Routes>
      </div>
    </Router>;
}